import React, {useEffect, useState,useRef  } from "react";
import { Box, Modal, Typography, TextField, Button } from "@material-ui/core";
import { CheckCircle,Cancel } from "@material-ui/icons"; // Confirmation Icon
import { formIoData } from "../consts";
// import Image from "../images/logo.png";
import NoDataImage from "../images/no-results.jpg";
import "formiojs/dist/formio.full.css";
import { Formio } from "react-formio";
import { callEndpoint } from "../ApiCall";
import { FormBuilder as FormBuilderIo } from "react-formio";
import Footer from "../inc/footer";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // Use a percentage to make it responsive
  maxWidth: "400px", // Limit max width
  maxHeight: "80vh", // Limit max height to 80% of viewport height
  overflowY: "auto", // Add scrolling when content exceeds max height
  backgroundColor: "#fff",
  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
  padding: "20px",
  borderRadius: "8px",
  textAlign: "center",
};

export const Fetch = (id) => {
    const body = {
      col: ["name","data"],
      filter: [
        ["park", "=", "0"],
        ["id", "=", id],
      ],
      table: "form",
    };
    const endpoint = "settingRoute.php";
    const action = "getSetting";
  
    return callEndpoint(body, endpoint, action);
  };
const Edit = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [noData, setNoData] = useState(false);
  const [formData, setFormData] = useState(formIoData); // Manage form data state
  const [formName, setFormName] = useState(""); // Manage form name
  const [modalOpen, setModalOpen] = useState(false); // Manage modal visibility
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false); // Confirmation modal
  const [confirmationModalError, setConfirmationModalError] = useState(false); // Confirmation modal
  const [alertModalOpen, setAlertModalOpen] = useState(false); // Alert modal for empty form
  var [heading, setHeading] = useState("");
  const params = new URLSearchParams(window.location.search);
  const id =  params.get("id");
  const isFirstFetch = useRef(true); // Prevent double Fetch calls


  useEffect(() => {
    if (isFirstFetch.current) {
      isFirstFetch.current = false; // Mark as processed
      if (id) {
        Fetch(id)
          .then((data) => {
            setLoading(false);
            if (data && data.data && data.data.length > 0) {
              setFormName(data.data[0].name);
              setHeading(data.data[0].name);
              const parsedData = JSON.parse(data.data[0].data);
              var combinedData = { display: "form",
                components: parsedData}
                setFormData( combinedData);
            } else {
                setNoData(true);
            }
          })
          .catch((err) => {
            setLoading(false);
            setError("Error fetching data.");
            console.error(err);
          });
      } else {
        setLoading(false);
        setNoData(true);
      }
    }
  }, [params,id]);

  // 🎯 S3 Video Click Handler - Intercept clicks on S3 links and open video modal
  useEffect(() => {
    const handleS3Click = (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      // Check if this is an S3/AWS link
      if (href.includes('amazonaws.com') || href.includes('s3') || href.endsWith('.mp4')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        console.log('Opening video modal for:', href);
        
        // Extract file info and open video modal
        const fileName = link.textContent || href.split('/').pop() || 'video.mp4';
        const isVideo = href.endsWith('.mp4') || href.endsWith('.webm') || href.endsWith('.mov');
        const isImage = href.endsWith('.jpg') || href.endsWith('.jpeg') || href.endsWith('.png') || href.endsWith('.gif');
        
        // Determine file type
        let fileType = 'application/octet-stream';
        if (isVideo) fileType = 'video/mp4';
        else if (isImage) fileType = 'image/jpeg';
        
        // Extract key from URL
        let s3Key = '';
        try {
          const urlObj = new URL(href);
          s3Key = urlObj.pathname.substring(1); // Remove leading slash
        } catch (err) {
          s3Key = href.split('.amazonaws.com/')[1] || '';
        }
        
        // Build file object that matches what s3.js expects
        const fileObj = {
          name: fileName,
          url: href,
          key: s3Key,
          type: fileType,
          storage: 's3'
        };
        
        // Get S3 provider and call downloadFile
        const s3Provider = Formio.Providers.getProvider('storage', 's3');
        if (s3Provider) {
          const provider = s3Provider(Formio);
          provider.downloadFile(fileObj);
        } else {
          console.error('S3 storage provider not found');
        }
      }
    };

    document.addEventListener('click', handleS3Click, true);
    
    return () => {
      document.removeEventListener('click', handleS3Click, true);
    };
  }, []);

  const handleSaveClick = () => {
    if (!formData || !formData.components || (formData.components.length === 1 && formData.components[0].action === 'submit')) {
      setAlertModalOpen(true); // Show alert modal
    } else {
      setModalOpen(true); // Open form name modal
    }
  };

  const saveResult = () => {
    if (!formData || !formData.components) {
      console.error("No form data available to save.");
      return;
    }

    const body={
        form_token: "ABCD12345678",
        name: formName.trim(),
        data: formData.components,
        id : id
      };
    const endpoint = "formRoute.php";
    const action = "updateBuilderForm";

    // Simulate API call
    callEndpoint(body, endpoint, action)
        .then((response) => {
          if(response.error === 0){
            setModalOpen(false); // Close input modal
            setConfirmationModalOpen(true); // Open confirmation modal
          }else{
            setModalOpen(false); // Close input modal
            setConfirmationModalError(true); // Open confirmation modal
          }
        })
        .catch((err) => {
          console.error("Error saving form:", err);
          alert("Failed to save the form. Please try again.");
        });
  };
  return (
    <div className="app-container">
      {/* Logo at the top */}
      <div>
        {/* <img className="topCenter" src={Image} alt="logo" /> */}
      </div>
      {loading && <div id="loader" className="loader"></div>}
      {/* Form Builder */}
      {!loading && error && (
          <div className="no-data-container">
            <img src={NoDataImage} alt="Error" className="no-data-image" />
            <h2>Error Fetching Data</h2>
            <p>Something went wrong. Please try again later.</p>
          </div>
        )}
      {!loading && !error && (
      <div>
            <h3>{heading}</h3>
      </div>)}
      {!loading && noData && (
          <div className="no-data-container">
            <img src={NoDataImage} alt="No Data" className="no-data-image" />
            <h2>No Data Found</h2>
          </div>
        )}
      {!loading && !error && !noData && (<div>
        <FormBuilderIo className="app-content"
          form={formData}
          onChange={(schema) => setFormData(schema)} // Update state when the form changes
          saveForm={(data) => setFormData(data)} // Save form data when Save Form button is clicked
          saveText="Save Form"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          style={{ marginTop: "20px" }}
        >
          Update Form
        </Button>
      </div>)}
      <Footer />

      {/* Modal for form name input */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
  <Box style={modalStyle}>
    <Typography variant="h6" component="h2" gutterBottom>
      Enter Form Name
    </Typography>
    <TextField
      fullWidth
      variant="outlined"
      label="Form Name"
      value={formName}
      onChange={(e) => setFormName(e.target.value)}
      style={{ marginBottom: "20px" }}
      error={!formName.trim()} // Highlight field in red if empty
      // helperText={!formName.trim() ? "Form name is required" : ""} // Show error message
    />
    <Button
      variant="contained"
      color="primary"
      onClick={saveResult}
      fullWidth
      disabled={!formName.trim()} // Disable button if formName is empty
    >
      Update
    </Button>
  </Box>
</Modal>

      {/* Confirmation Modal */}
      <Modal
        open={confirmationModalOpen}
        onClose={() => setConfirmationModalOpen(false)}
      >
        <Box style={modalStyle}>
          <CheckCircle
            style={{ fontSize: "50px", color: "green", marginBottom: "20px" }}
          />
          <Typography variant="h6" component="h2" gutterBottom>
            Form Updated Successfully!
          </Typography>
          <Typography variant="body1" gutterBottom>
            Form "{formName}" has been Updated.
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={confirmationModalError}
        onClose={() => setConfirmationModalError(false)}
      >
        <Box style={modalStyle}>
          <Cancel
            style={{ fontSize: "50px", color: "red", marginBottom: "20px" }}
          />
          <Typography variant="h6" component="h2" gutterBottom>
            Error While Updating!
          </Typography>
        </Box>
      </Modal>

      {/* Alert Modal for Empty Form */}
      <Modal open={alertModalOpen} onClose={() => setAlertModalOpen(false)}>
        <Box style={modalStyle}>
        <Cancel
            style={{ fontSize: "50px", color: "red", marginBottom: "20px" }}
          />
          <Typography variant="h6" component="h2" gutterBottom>
            Form Should Not Be Empty
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setAlertModalOpen(false)}
            fullWidth
          >
            OK
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default Edit;
